module.exports = __webpack_public_path__ + "img/jilinUniversity.433f2175.png";